import React from "react";
import { ReportName } from "types/gql-types";
import { ReportTable } from "./report-table";

export const ApplicationStatus: React.FC<{ path: string }> = () => (
  <ReportTable reportName={ReportName.INTEREST_STATUS} includeTitle />
);
